import { render, staticRenderFns } from "./ClickRenderer.vue?vue&type=template&id=2a526589&"
import script from "./ClickRenderer.vue?vue&type=script&lang=js&"
export * from "./ClickRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports